import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { tapi, getTenantToken, setTenantToken } from "../lib/tenant";
import { API } from "../lib/api";

const TenantContext = createContext(null);
const ORIGIN = API.replace(/\/api$/, "");

export function TenantProvider({ sub, basePath, children }) {
  const [config, setConfig] = useState(undefined); // undefined loading, null offline
  const [me, setMe] = useState(undefined); // undefined loading, null logged out
  const [meError, setMeError] = useState(null);

  useEffect(() => {
    setConfig(undefined);
    tapi.get(`/t/${sub}/config`).then((r) => setConfig(r.data)).catch(() => setConfig(null));
  }, [sub]);

  const refreshMe = useCallback(async () => {
    if (!getTenantToken()) { setMe(null); return null; }
    try {
      const { data } = await tapi.get(`/t/${sub}/me`);
      setMe(data); setMeError(null);
      return data;
    } catch (e) {
      if (e.response?.status === 401 || e.response?.status === 403) setTenantToken(null);
      setMe(null); setMeError(e.response?.status || "error");
      return null;
    }
  }, [sub]);

  useEffect(() => { if (config) refreshMe(); }, [config, refreshMe]);

  const logout = useCallback(() => { setTenantToken(null); setMe(null); }, []);

  const value = useMemo(() => ({
    sub, basePath, config, me, meError, refreshMe, logout, setMe,
    brand: config?.brand_primary_color || "#0A8B85",
    logoSrc: config?.logo_url ? `${ORIGIN}${config.logo_url}` : null,
    to: (p) => `${basePath}${p}`,
  }), [sub, basePath, config, me, meError, refreshMe, logout]);

  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>;
}

export const useTenant = () => useContext(TenantContext);
